//
//
// import React, { useEffect, useState, useRef } from "react";
// import { useSearchParams } from "react-router-dom";
// import { doc, onSnapshot } from "firebase/firestore";
// import { createClients } from "../firebase/clients";
//
// const INTEREST_KEYS = [
//   { key: "music", label: "Music", icon: "🎵", border: "border-[#F6A655]", bg: "bg-gradient-to-r from-[#F6A655] to-[#F2800D]" },
//   { key: "fitness", label: "Fitness", icon: "💪", border: "border-[#78C8F0]", bg: "bg-gradient-to-r from-[#67C5E4] to-[#3399CC]" },
//   { key: "art", label: "Art", icon: "🎨", border: "border-[#D98CF2]", bg: "bg-gradient-to-r from-[#CF86EA] to-[#9D54B8]" },
//   { key: "travel", label: "Travel", icon: "✈️", border: "border-[#7192F4]", bg: "bg-gradient-to-r from-[#3366CC] to-[#24368F]" },
//   { key: "food", label: "Food", icon: "🍔", border: "border-[#FFD24D]", bg: "bg-gradient-to-r from-[#EBBD60] to-[#F2A60D]" },
//   { key: "sports", label: "Sports", icon: "⚽", border: "border-[#6ED94A]", bg: "bg-gradient-to-r from-[#6DCA4E] to-[#48A329]" },
// ];
//
// const ATMOSPHERE_KEYS = [
//   { key: "date", label: "Open to date", icon: "❤️", border: "border-[#FF0000]", bg: "bg-gradient-to-r from-[#FF6B6B] to-[#FF0000]" },
//   { key: "banter", label: "Open to banter", icon: "💬", border: "border-[#FC8C4F]", bg: "bg-gradient-to-r from-[#FFB07A] to-[#FC8C4F]" },
//   { key: "vibe", label: "Just here for vibes", icon: "👻", border: "border-[#989FBB]", bg: "bg-gradient-to-r from-[#C1C6DD] to-[#989FBB]" },
// ];
//
// export default function TVDashboard() {
//   const [searchParams] = useSearchParams();
//   const eventId = searchParams.get("eventId");
//
//   const [metrics, setMetrics] = useState({
//     totalParticipants: 0,
//     interests: {},
//     eveningAtmosphere: { date: 0, banter: 0, vibe: 0 },
//   });
//
//   const [highlightedInterests, setHighlightedInterests] = useState([]);
//   const [highlightedAtmosphere, setHighlightedAtmosphere] = useState([]);
//
//   const clientsRef = useRef({});
//   const prevInterestsRef = useRef(null);
//   const prevAtmosphereRef = useRef(null);
//   const highlightTimersRef = useRef([]);
//
//   useEffect(() => {
//     if (!eventId) return;
//
//     clientsRef.current = createClients();
//     const { db } = clientsRef.current;
//
//     const unsub = onSnapshot(
//       doc(db, "events", eventId),
//       (snap) => {
//         if (!snap.exists()) return;
//
//         const data = snap.data();
//
//         const interestsData = data.interestCounters
//           ? { ...data.interestCounters }
//           : {};
//
//         const atmosphereData = data.atmosphereCounters
//           ? { ...data.atmosphereCounters }
//           : { date: 0, banter: 0, vibe: 0 };
//
//         const newTotal = data.totalParticipants || 0;
//
//         if (!prevInterestsRef.current) {
//           prevInterestsRef.current = { ...interestsData };
//           prevAtmosphereRef.current = { ...atmosphereData };
//
//           setMetrics({
//             totalParticipants: newTotal,
//             interests: interestsData,
//             eveningAtmosphere: atmosphereData,
//           });
//
//           return;
//         }
//
//         // interest deltas
//         const interestDeltas = INTEREST_KEYS.map(({ key }) => {
//           const diff =
//             (interestsData[key] || 0) -
//             (prevInterestsRef.current[key] || 0);
//           return diff > 0 ? { key, delta: diff } : null;
//         }).filter(Boolean);
//
//         if (interestDeltas.length > 0) {
//           setHighlightedInterests((prev) => [...prev, ...interestDeltas]);
//
//           const t = setTimeout(() => {
//             setHighlightedInterests((prev) =>
//               prev.filter((h) => !interestDeltas.some((d) => d.key === h.key))
//             );
//           }, 5000);
//
//           highlightTimersRef.current.push(t);
//         }
//
//         // atmosphere deltas
//         const atmosphereDeltas = ATMOSPHERE_KEYS.map(({ key }) => {
//           const diff =
//             (atmosphereData[key] || 0) -
//             (prevAtmosphereRef.current[key] || 0);
//           return diff > 0 ? { key, delta: diff } : null;
//         }).filter(Boolean);
//
//         if (atmosphereDeltas.length > 0) {
//           setHighlightedAtmosphere((prev) => [...prev, ...atmosphereDeltas]);
//
//           const t = setTimeout(() => {
//             setHighlightedAtmosphere((prev) =>
//               prev.filter((h) =>
//                 !atmosphereDeltas.some((d) => d.key === h.key)
//               )
//             );
//           }, 5000);
//
//           highlightTimersRef.current.push(t);
//         }
//
//         prevInterestsRef.current = { ...interestsData };
//         prevAtmosphereRef.current = { ...atmosphereData };
//
//         setMetrics({
//           totalParticipants: newTotal,
//           interests: interestsData,
//           eveningAtmosphere: atmosphereData,
//         });
//       }
//     );
//
//     return () => {
//       unsub();
//       highlightTimersRef.current.forEach((t) => clearTimeout(t));
//       highlightTimersRef.current = [];
//     };
//   }, [eventId]);
//
//   const totalParticipants = metrics.totalParticipants || 0;
//
//   return (
//     <div className="min-h-screen flex items-center justify-center bg-black text-white p-6">
//
//       <div className="flex flex-row gap-10 w-full max-w-7xl">
//
//         {/* TOTAL PANEL */}
//         <div className="flex flex-col items-center justify-center flex-1">
//
//           <img
//             src={process.env.PUBLIC_URL + "/goBanterHeart_red.svg"}
//             alt="Heart"
//             className="h-40 mb-10"
//           />
//
//           <div className="text-4xl font-bold mb-4 text-center">
//             Total Participants
//           </div>
//
//           <div className="text-[160px] font-bold">
//             {totalParticipants}
//           </div>
//
//         </div>
//
//         {/* INTERESTS PANEL */}
//         <div className="flex-1">
//
//           <div className="text-2xl font-bold mb-6 text-center">
//             Members by interests
//           </div>
//
//           <div className="space-y-4">
//
//             {INTEREST_KEYS.map((it) => {
//               const count = metrics.interests[it.key] || 0;
//               const highlightObj = highlightedInterests.find(
//                 (h) => h.key === it.key
//               );
//
//               const isHighlighted = Boolean(highlightObj);
//               const delta = highlightObj?.delta || 0;
//
//               return (
//                 <div className="flex items-center gap-3" key={it.key}>
//
//                   <div className="w-16 flex justify-end pr-2">
//                     {isHighlighted && (
//                       <div className="flex items-center text-lg font-bold">
//                         <span className="text-2xl">{it.icon}</span>
//                         <span className="ml-1">+{delta}</span>
//                       </div>
//                     )}
//                   </div>
//
//                   <div
//                     className={`flex items-center justify-between flex-1 p-4 rounded-2xl border-2 transition-all duration-300 transform ${
//                       isHighlighted
//                         ? `${it.bg} text-white border-transparent scale-105 shadow-2xl`
//                         : `bg-transparent ${it.border}`
//                     }`}
//                   >
//
//                     <div className="flex items-center gap-3">
//                       <span className="text-xl">{it.icon}</span>
//                       <span>{it.label}</span>
//                     </div>
//
//                     <div className="font-bold text-lg">
//                       {count}
//                     </div>
//
//                   </div>
//
//                 </div>
//               );
//             })}
//
//           </div>
//
//         </div>
//
//         {/* ATMOSPHERE PANEL */}
//         <div className="flex-1">
//
//           <div className="text-2xl font-bold mb-6 text-center">
//             Members by atmosphere
//           </div>
//
//           <div className="space-y-4">
//
//             {ATMOSPHERE_KEYS.map((it) => {
//               const count = metrics.eveningAtmosphere[it.key] || 0;
//
//               const highlightObj = highlightedAtmosphere.find(
//                 (h) => h.key === it.key
//               );
//
//               const isHighlighted = Boolean(highlightObj);
//               const delta = highlightObj?.delta || 0;
//
//               return (
//                 <div className="flex items-center gap-3" key={it.key}>
//
//                   <div className="w-16 flex justify-end pr-2">
//                     {isHighlighted && (
//                       <div className="flex items-center text-lg font-bold">
//                         <span className="text-2xl">{it.icon}</span>
//                         <span className="ml-1">+{delta}</span>
//                       </div>
//                     )}
//                   </div>
//
//                   <div
//                     className={`flex items-center justify-between flex-1 p-4 rounded-2xl border-2 transition-all duration-300 transform ${
//                       isHighlighted
//                         ? `${it.bg} border-transparent scale-105 shadow-2xl`
//                         : `bg-transparent ${it.border}`
//                     }`}
//                   >
//
//                     <div className="flex items-center gap-3">
//                       <span className="text-xl">{it.icon}</span>
//                       <span>{it.label}</span>
//                     </div>
//
//                     <div className="font-bold text-lg">
//                       {count}
//                     </div>
//
//                   </div>
//
//                 </div>
//               );
//             })}
//
//           </div>
//
//         </div>
//
//       </div>
//
//     </div>
//   );
// }
// import React, { useEffect, useState, useRef } from "react";
// import { useSearchParams } from "react-router-dom";
// import { doc, onSnapshot } from "firebase/firestore";
// import { createClients } from "../firebase/clients";
//
// const INTEREST_KEYS = [
//   { key: "music", label: "Music", icon: "🎵", border: "border-[#F6A655]", bg: "bg-gradient-to-r from-[#F6A655] to-[#F2800D]" },
//   { key: "fitness", label: "Fitness", icon: "💪", border: "border-[#78C8F0]", bg: "bg-gradient-to-r from-[#67C5E4] to-[#3399CC]" },
//   { key: "art", label: "Art", icon: "🎨", border: "border-[#D98CF2]", bg: "bg-gradient-to-r from-[#CF86EA] to-[#9D54B8]" },
//   { key: "travel", label: "Travel", icon: "✈️", border: "border-[#7192F4]", bg: "bg-gradient-to-r from-[#3366CC] to-[#24368F]" },
//   { key: "food", label: "Food", icon: "🍔", border: "border-[#FFD24D]", bg: "bg-gradient-to-r from-[#EBBD60] to-[#F2A60D]" },
//   { key: "sports", label: "Sports", icon: "⚽", border: "border-[#6ED94A]", bg: "bg-gradient-to-r from-[#6DCA4E] to-[#48A329]" },
// ];
//
// const ATMOSPHERE_KEYS = [
//   { key: "date", label: "Open to date", icon: "❤️", border: "border-[#FF0000]", bg: "bg-gradient-to-r from-[#FF6B6B] to-[#FF0000]" },
//   { key: "banter", label: "Open to banter", icon: "💬", border: "border-[#FC8C4F]", bg: "bg-gradient-to-r from-[#FFB07A] to-[#FC8C4F]" },
//   { key: "vibe", label: "Just here for vibes", icon: "👻", border: "border-[#989FBB]", bg: "bg-gradient-to-r from-[#C1C6DD] to-[#989FBB]" },
// ];
//
// export default function TVDashboard() {
//   const [searchParams] = useSearchParams();
//   const eventId = searchParams.get("eventId");
//
//   const [metrics, setMetrics] = useState({
//     totalParticipants: 0,
//     interests: {},
//     eveningAtmosphere: { date: 0, banter: 0, vibe: 0 },
//   });
//
//   const [highlightedInterests, setHighlightedInterests] = useState([]);
//   const [highlightedAtmosphere, setHighlightedAtmosphere] = useState([]);
//
//   const clientsRef = useRef({});
//   const prevInterestsRef = useRef(null);
//   const prevAtmosphereRef = useRef(null);
//   const highlightTimersRef = useRef([]);
//
//   useEffect(() => {
//     if (!eventId) return;
//
//     clientsRef.current = createClients();
//     const { db } = clientsRef.current;
//
//     const unsub = onSnapshot(
//       doc(db, "events", eventId),
//       (snap) => {
//         if (!snap.exists()) return;
//
//         const data = snap.data();
//
//         const interestsData = data.interestCounters || {};
//         const atmosphereData = data.atmosphereCounters || { date: 0, banter: 0, vibe: 0 };
//         const newTotal = data.totalParticipants || 0;
//
//         if (!prevInterestsRef.current) {
//           prevInterestsRef.current = { ...interestsData };
//           prevAtmosphereRef.current = { ...atmosphereData };
//
//           setMetrics({
//             totalParticipants: newTotal,
//             interests: interestsData,
//             eveningAtmosphere: atmosphereData,
//           });
//
//           return;
//         }
//
//         const interestDeltas = INTEREST_KEYS.map(({ key }) => {
//           const diff = (interestsData[key] || 0) - (prevInterestsRef.current[key] || 0);
//           return diff > 0 ? { key, delta: diff } : null;
//         }).filter(Boolean);
//
//         if (interestDeltas.length > 0) {
//           setHighlightedInterests((prev) => [...prev, ...interestDeltas]);
//
//           const t = setTimeout(() => {
//             setHighlightedInterests((prev) =>
//               prev.filter((h) => !interestDeltas.some((d) => d.key === h.key))
//             );
//           }, 5000);
//
//           highlightTimersRef.current.push(t);
//         }
//
//         const atmosphereDeltas = ATMOSPHERE_KEYS.map(({ key }) => {
//           const diff = (atmosphereData[key] || 0) - (prevAtmosphereRef.current[key] || 0);
//           return diff > 0 ? { key, delta: diff } : null;
//         }).filter(Boolean);
//
//         if (atmosphereDeltas.length > 0) {
//           setHighlightedAtmosphere((prev) => [...prev, ...atmosphereDeltas]);
//
//           const t = setTimeout(() => {
//             setHighlightedAtmosphere((prev) =>
//               prev.filter((h) => !atmosphereDeltas.some((d) => d.key === h.key))
//             );
//           }, 5000);
//
//           highlightTimersRef.current.push(t);
//         }
//
//         prevInterestsRef.current = { ...interestsData };
//         prevAtmosphereRef.current = { ...atmosphereData };
//
//         setMetrics({
//           totalParticipants: newTotal,
//           interests: interestsData,
//           eveningAtmosphere: atmosphereData,
//         });
//       }
//     );
//
//     return () => {
//       unsub();
//       highlightTimersRef.current.forEach((t) => clearTimeout(t));
//       highlightTimersRef.current = [];
//     };
//   }, [eventId]);
//
//   const totalParticipants = metrics.totalParticipants || 0;
//
//   return (
//     <div className="min-h-screen w-full flex items-center justify-center bg-black text-white p-4 lg:p-6 overflow-x-hidden">
//
//       <div className="flex flex-col lg:flex-row gap-10 w-full max-w-7xl items-center lg:items-start">
//
//         {/* TOTAL */}
//         <div className="flex flex-col items-center justify-center flex-1">
//
//           <img
//             src={process.env.PUBLIC_URL + "/goBanterHeart_red.svg"}
//             alt="Heart"
//             className="h-24 lg:h-40 mb-6 lg:mb-10"
//           />
//
//           <div className="text-2xl lg:text-4xl font-bold mb-4 text-center">
//             Total Participants
//           </div>
//
//           <div className="text-[90px] lg:text-[160px] font-bold">
//             {totalParticipants}
//           </div>
//
//         </div>
//
//         {/* INTERESTS */}
//         <div className="flex-1 w-full max-w-md mx-auto">
//
//           <div className="text-xl lg:text-2xl font-bold mb-6 text-center">
//             Members by interests
//           </div>
//
//           <div className="space-y-4">
//
//             {INTEREST_KEYS.map((it) => {
//               const count = metrics.interests[it.key] || 0;
//               const highlightObj = highlightedInterests.find((h) => h.key === it.key);
//
//               const isHighlighted = Boolean(highlightObj);
//               const delta = highlightObj?.delta || 0;
//
//               return (
//                 <div className="flex items-center gap-3" key={it.key}>
//
//                   <div className="w-16 flex justify-end pr-2">
//                     {isHighlighted && (
//                       <div className="flex items-center text-lg font-bold">
//                         <span className="text-2xl">{it.icon}</span>
//                         <span className="ml-1">+{delta}</span>
//                       </div>
//                     )}
//                   </div>
//
//                   <div
//                     className={`flex items-center justify-between flex-1 p-4 rounded-2xl border-2 transition-all duration-300 transform ${
//                       isHighlighted
//                         ? `${it.bg} text-white border-transparent scale-105 shadow-2xl`
//                         : `bg-transparent ${it.border}`
//                     }`}
//                   >
//
//                     <div className="flex items-center gap-3">
//                       <span className="text-xl">{it.icon}</span>
//                       <span>{it.label}</span>
//                     </div>
//
//                     <div className="font-bold text-lg">
//                       {count}
//                     </div>
//
//                   </div>
//
//                 </div>
//               );
//             })}
//
//           </div>
//
//         </div>
//
//         {/* ATMOSPHERE */}
//         <div className="flex-1 w-full max-w-md mx-auto">
//
//           <div className="text-xl lg:text-2xl font-bold mb-6 text-center">
//             Members by atmosphere
//           </div>
//
//           <div className="space-y-4">
//
//             {ATMOSPHERE_KEYS.map((it) => {
//               const count = metrics.eveningAtmosphere[it.key] || 0;
//               const highlightObj = highlightedAtmosphere.find((h) => h.key === it.key);
//
//               const isHighlighted = Boolean(highlightObj);
//               const delta = highlightObj?.delta || 0;
//
//               return (
//                 <div className="flex items-center gap-3" key={it.key}>
//
//                   <div className="w-16 flex justify-end pr-2">
//                     {isHighlighted && (
//                       <div className="flex items-center text-lg font-bold">
//                         <span className="text-2xl">{it.icon}</span>
//                         <span className="ml-1">+{delta}</span>
//                       </div>
//                     )}
//                   </div>
//
//                   <div
//                     className={`flex items-center justify-between flex-1 p-4 rounded-2xl border-2 transition-all duration-300 transform ${
//                       isHighlighted
//                         ? `${it.bg} border-transparent scale-105 shadow-2xl`
//                         : `bg-transparent ${it.border}`
//                     }`}
//                   >
//
//                     <div className="flex items-center gap-3">
//                       <span className="text-xl">{it.icon}</span>
//                       <span>{it.label}</span>
//                     </div>
//
//                     <div className="font-bold text-lg">
//                       {count}
//                     </div>
//
//                   </div>
//
//                 </div>
//               );
//             })}
//
//           </div>
//
//         </div>
//
//       </div>
//
//     </div>
//   );
// }

// import React, { useEffect, useState, useRef } from "react";
// import { useSearchParams } from "react-router-dom";
// import { doc, onSnapshot } from "firebase/firestore";
// import { createClients } from "../firebase/clients";
//
// const INTEREST_KEYS = [
//   { key: "music", label: "Music", icon: "🎵", border: "border-[#F6A655]", bg: "bg-gradient-to-r from-[#F6A655] to-[#F2800D]" },
//   { key: "fitness", label: "Fitness", icon: "💪", border: "border-[#78C8F0]", bg: "bg-gradient-to-r from-[#67C5E4] to-[#3399CC]" },
//   { key: "art", label: "Art", icon: "🎨", border: "border-[#D98CF2]", bg: "bg-gradient-to-r from-[#CF86EA] to-[#9D54B8]" },
//   { key: "travel", label: "Travel", icon: "✈️", border: "border-[#7192F4]", bg: "bg-gradient-to-r from-[#3366CC] to-[#24368F]" },
//   { key: "food", label: "Food", icon: "🍔", border: "border-[#FFD24D]", bg: "bg-gradient-to-r from-[#EBBD60] to-[#F2A60D]" },
//   { key: "sports", label: "Sports", icon: "⚽", border: "border-[#6ED94A]", bg: "bg-gradient-to-r from-[#6DCA4E] to-[#48A329]" },
// ];
//
// const ATMOSPHERE_KEYS = [
//   { key: "date", label: "Open to date", icon: "❤️", border: "border-[#FF0000]", bg: "bg-gradient-to-r from-[#FF6B6B] to-[#FF0000]" },
//   { key: "banter", label: "Open to banter", icon: "💬", border: "border-[#FC8C4F]", bg: "bg-gradient-to-r from-[#FFB07A] to-[#FC8C4F]" },
//   { key: "vibe", label: "Just here for vibes", icon: "👻", border: "border-[#989FBB]", bg: "bg-gradient-to-r from-[#C1C6DD] to-[#989FBB]" },
// ];
//
// export default function TVDashboard() {
//   const [searchParams] = useSearchParams();
//   const eventId = searchParams.get("eventId");
//
//   const [metrics, setMetrics] = useState({
//     totalParticipants: 0,
//     interests: {},
//     eveningAtmosphere: { date: 0, banter: 0, vibe: 0 },
//   });
//
//   const [highlightedInterests, setHighlightedInterests] = useState([]);
//   const [highlightedAtmosphere, setHighlightedAtmosphere] = useState([]);
//
//   const clientsRef = useRef({});
//   const prevInterestsRef = useRef(null);
//   const prevAtmosphereRef = useRef(null);
//   const highlightTimersRef = useRef([]);
//
//   useEffect(() => {
//     if (!eventId) return;
//
//     clientsRef.current = createClients();
//     const { db } = clientsRef.current;
//
//     const unsub = onSnapshot(
//       doc(db, "events", eventId),
//       (snap) => {
//         if (!snap.exists()) return;
//
//         const data = snap.data();
//
//         const interestsData = data.interestCounters || {};
//         const atmosphereData = data.atmosphereCounters || { date: 0, banter: 0, vibe: 0 };
//         const newTotal = data.totalParticipants || 0;
//
//         if (!prevInterestsRef.current) {
//           prevInterestsRef.current = { ...interestsData };
//           prevAtmosphereRef.current = { ...atmosphereData };
//
//           setMetrics({
//             totalParticipants: newTotal,
//             interests: interestsData,
//             eveningAtmosphere: atmosphereData,
//           });
//
//           return;
//         }
//
//         const interestDeltas = INTEREST_KEYS.map(({ key }) => {
//           const diff = (interestsData[key] || 0) - (prevInterestsRef.current[key] || 0);
//           return diff > 0 ? { key, delta: diff } : null;
//         }).filter(Boolean);
//
//         if (interestDeltas.length > 0) {
//           setHighlightedInterests((prev) => [...prev, ...interestDeltas]);
//
//           const t = setTimeout(() => {
//             setHighlightedInterests((prev) =>
//               prev.filter((h) => !interestDeltas.some((d) => d.key === h.key))
//             );
//           }, 5000);
//
//           highlightTimersRef.current.push(t);
//         }
//
//         const atmosphereDeltas = ATMOSPHERE_KEYS.map(({ key }) => {
//           const diff = (atmosphereData[key] || 0) - (prevAtmosphereRef.current[key] || 0);
//           return diff > 0 ? { key, delta: diff } : null;
//         }).filter(Boolean);
//
//         if (atmosphereDeltas.length > 0) {
//           setHighlightedAtmosphere((prev) => [...prev, ...atmosphereDeltas]);
//
//           const t = setTimeout(() => {
//             setHighlightedAtmosphere((prev) =>
//               prev.filter((h) => !atmosphereDeltas.some((d) => d.key === h.key))
//             );
//           }, 5000);
//
//           highlightTimersRef.current.push(t);
//         }
//
//         prevInterestsRef.current = { ...interestsData };
//         prevAtmosphereRef.current = { ...atmosphereData };
//
//         setMetrics({
//           totalParticipants: newTotal,
//           interests: interestsData,
//           eveningAtmosphere: atmosphereData,
//         });
//       }
//     );
//
//     return () => {
//       unsub();
//       highlightTimersRef.current.forEach((t) => clearTimeout(t));
//       highlightTimersRef.current = [];
//     };
//   }, [eventId]);
//
//   const totalParticipants = metrics.totalParticipants || 0;
//
//   return (
//     <div className="min-h-screen w-full flex items-center justify-center bg-black text-white p-4 lg:p-6 overflow-x-hidden">
//
//       <div className="flex flex-col lg:flex-row gap-10 w-full max-w-7xl">
//
//         {/* TOTAL */}
//         <div className="flex flex-col items-center justify-center flex-1">
//
//           <img
//             src={process.env.PUBLIC_URL + "/goBanterHeart_red.svg"}
//             alt="Heart"
//             className="h-24 lg:h-40 mb-6 lg:mb-10"
//           />
//
//           <div className="text-2xl lg:text-4xl font-bold mb-4 text-center">
//             Total Participants
//           </div>
//
//           <div className="text-[90px] lg:text-[160px] font-bold">
//             {totalParticipants}
//           </div>
//
//         </div>
//
//         {/* INTERESTS */}
//         <div className="flex-1">
//
//           <div className="text-xl lg:text-2xl font-bold mb-6 text-center">
//             Members by interests
//           </div>
//
//           <div className="space-y-4">
//
//             {INTEREST_KEYS.map((it) => {
//               const count = metrics.interests[it.key] || 0;
//               const highlightObj = highlightedInterests.find((h) => h.key === it.key);
//
//               const isHighlighted = Boolean(highlightObj);
//               const delta = highlightObj?.delta || 0;
//
//               return (
//                 <div className="flex items-center gap-3" key={it.key}>
//
//                   <div className="w-16 flex justify-end pr-2">
//                     {isHighlighted && (
//                       <div className="flex items-center text-lg font-bold">
//                         <span className="text-2xl">{it.icon}</span>
//                         <span className="ml-1">+{delta}</span>
//                       </div>
//                     )}
//                   </div>
//
//                   <div
//                     className={`flex items-center justify-between flex-1 p-4 rounded-2xl border-2 transition-all duration-300 transform ${
//                       isHighlighted
//                         ? `${it.bg} text-white border-transparent scale-105 shadow-2xl`
//                         : `bg-transparent ${it.border}`
//                     }`}
//                   >
//
//                     <div className="flex items-center gap-3">
//                       <span className="text-xl">{it.icon}</span>
//                       <span>{it.label}</span>
//                     </div>
//
//                     <div className="font-bold text-lg">
//                       {count}
//                     </div>
//
//                   </div>
//
//                 </div>
//               );
//             })}
//
//           </div>
//
//         </div>
//
//         {/* ATMOSPHERE */}
//         <div className="flex-1">
//
//           <div className="text-xl lg:text-2xl font-bold mb-6 text-center">
//             Members by atmosphere
//           </div>
//
//           <div className="space-y-4">
//
//             {ATMOSPHERE_KEYS.map((it) => {
//               const count = metrics.eveningAtmosphere[it.key] || 0;
//               const highlightObj = highlightedAtmosphere.find((h) => h.key === it.key);
//
//               const isHighlighted = Boolean(highlightObj);
//               const delta = highlightObj?.delta || 0;
//
//               return (
//                 <div className="flex items-center gap-3" key={it.key}>
//
//                   <div className="w-16 flex justify-end pr-2">
//                     {isHighlighted && (
//                       <div className="flex items-center text-lg font-bold">
//                         <span className="text-2xl">{it.icon}</span>
//                         <span className="ml-1">+{delta}</span>
//                       </div>
//                     )}
//                   </div>
//
//                   <div
//                     className={`flex items-center justify-between flex-1 p-4 rounded-2xl border-2 transition-all duration-300 transform ${
//                       isHighlighted
//                         ? `${it.bg} border-transparent scale-105 shadow-2xl`
//                         : `bg-transparent ${it.border}`
//                     }`}
//                   >
//
//                     <div className="flex items-center gap-3">
//                       <span className="text-xl">{it.icon}</span>
//                       <span>{it.label}</span>
//                     </div>
//
//                     <div className="font-bold text-lg">
//                       {count}
//                     </div>
//
//                   </div>
//
//                 </div>
//               );
//             })}
//
//           </div>
//
//         </div>
//
//       </div>
//
//     </div>
//   );
// }
import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import { createClients } from "../firebase/clients";

const INTEREST_KEYS = [
  { key: "music", label: "Music", icon: "🎵", border: "border-[#F6A655]", bg: "bg-gradient-to-r from-[#F6A655] to-[#F2800D]" },
  { key: "fitness", label: "Fitness", icon: "💪", border: "border-[#78C8F0]", bg: "bg-gradient-to-r from-[#67C5E4] to-[#3399CC]" },
  { key: "art", label: "Art", icon: "🎨", border: "border-[#D98CF2]", bg: "bg-gradient-to-r from-[#CF86EA] to-[#9D54B8]" },
  { key: "travel", label: "Travel", icon: "✈️", border: "border-[#7192F4]", bg: "bg-gradient-to-r from-[#3366CC] to-[#24368F]" },
  { key: "food", label: "Food", icon: "🍔", border: "border-[#FFD24D]", bg: "bg-gradient-to-r from-[#EBBD60] to-[#F2A60D]" },
  { key: "sports", label: "Sports", icon: "⚽", border: "border-[#6ED94A]", bg: "bg-gradient-to-r from-[#6DCA4E] to-[#48A329]" },
];

const ATMOSPHERE_KEYS = [
  { key: "date", label: "Open to date", icon: "❤️", border: "border-[#FF0000]", bg: "bg-gradient-to-r from-[#FF6B6B] to-[#FF0000]" },
  { key: "banter", label: "Open to banter", icon: "💬", border: "border-[#FC8C4F]", bg: "bg-gradient-to-r from-[#FFB07A] to-[#FC8C4F]" },
  { key: "vibe", label: "Just here for vibes", icon: "👻", border: "border-[#989FBB]", bg: "bg-gradient-to-r from-[#C1C6DD] to-[#989FBB]" },
];

export default function TVDashboard() {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("eventId");

  const [metrics, setMetrics] = useState({
    totalParticipants: 0,
    interests: {},
    eveningAtmosphere: { date: 0, banter: 0, vibe: 0 },
  });

  const [highlightedInterests, setHighlightedInterests] = useState([]);
  const [highlightedAtmosphere, setHighlightedAtmosphere] = useState([]);

  const clientsRef = useRef({});
  const prevInterestsRef = useRef(null);
  const prevAtmosphereRef = useRef(null);
  const highlightTimersRef = useRef([]);

  useEffect(() => {
    if (!eventId) return;

    clientsRef.current = createClients();
    const { db } = clientsRef.current;

    const unsub = onSnapshot(
      doc(db, "events", eventId),
      (snap) => {
        if (!snap.exists()) return;

        const data = snap.data();

        const interestsData = data.interestCounters || {};
        const atmosphereData = data.atmosphereCounters || { date: 0, banter: 0, vibe: 0 };
        const newTotal = data.totalParticipants || 0;

        if (!prevInterestsRef.current) {
          prevInterestsRef.current = { ...interestsData };
          prevAtmosphereRef.current = { ...atmosphereData };

          setMetrics({
            totalParticipants: newTotal,
            interests: interestsData,
            eveningAtmosphere: atmosphereData,
          });

          return;
        }

        const interestDeltas = INTEREST_KEYS.map(({ key }) => {
          const diff = (interestsData[key] || 0) - (prevInterestsRef.current[key] || 0);
          return diff > 0 ? { key, delta: diff } : null;
        }).filter(Boolean);

        if (interestDeltas.length > 0) {
          setHighlightedInterests((prev) => [...prev, ...interestDeltas]);

          const t = setTimeout(() => {
            setHighlightedInterests((prev) =>
              prev.filter((h) => !interestDeltas.some((d) => d.key === h.key))
            );
          }, 5000);

          highlightTimersRef.current.push(t);
        }

        const atmosphereDeltas = ATMOSPHERE_KEYS.map(({ key }) => {
          const diff = (atmosphereData[key] || 0) - (prevAtmosphereRef.current[key] || 0);
          return diff > 0 ? { key, delta: diff } : null;
        }).filter(Boolean);

        if (atmosphereDeltas.length > 0) {
          setHighlightedAtmosphere((prev) => [...prev, ...atmosphereDeltas]);

          const t = setTimeout(() => {
            setHighlightedAtmosphere((prev) =>
              prev.filter((h) => !atmosphereDeltas.some((d) => d.key === h.key))
            );
          }, 5000);

          highlightTimersRef.current.push(t);
        }

        prevInterestsRef.current = { ...interestsData };
        prevAtmosphereRef.current = { ...atmosphereData };

        setMetrics({
          totalParticipants: newTotal,
          interests: interestsData,
          eveningAtmosphere: atmosphereData,
        });
      }
    );

    return () => {
      unsub();
      highlightTimersRef.current.forEach((t) => clearTimeout(t));
      highlightTimersRef.current = [];
    };
  }, [eventId]);

  const totalParticipants = metrics.totalParticipants || 0;

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-black text-white p-4 lg:p-6 overflow-x-hidden">

      <div className="flex flex-col lg:flex-row gap-10 w-full max-w-7xl mx-auto justify-center">

        {/* TOTAL PARTICIPANTS */}
        <div className="flex flex-col items-center justify-center flex-1 w-full max-w-xs">

          <img
            src={process.env.PUBLIC_URL + "/goBanterHeart_red.svg"}
            alt="Heart"
            className="h-24 lg:h-40 mb-6 lg:mb-10"
          />

          <div className="text-2xl lg:text-4xl font-bold mb-4 text-center">
            Total Participants
          </div>

          <div className="text-[90px] lg:text-[160px] font-bold">
            {totalParticipants}
          </div>

        </div>

        {/* MEMBERS BY INTERESTS */}
        <div className="flex-1 w-full flex flex-col items-center max-w-md">

          <div className="text-xl lg:text-2xl font-bold mb-6 text-center">
            Members by interests
          </div>

          <div className="space-y-4 w-full">

            {INTEREST_KEYS.map((it) => {
              const count = metrics.interests[it.key] || 0;
              const highlightObj = highlightedInterests.find((h) => h.key === it.key);

              const isHighlighted = Boolean(highlightObj);
              const delta = highlightObj?.delta || 0;

              return (
                <div className="flex items-center gap-3" key={it.key}>

                  <div className="w-16 flex justify-end pr-2">
                    {isHighlighted && (
                      <div className="flex items-center text-lg font-bold">
                        <span className="text-2xl">{it.icon}</span>
                        <span className="ml-1">+{delta}</span>
                      </div>
                    )}
                  </div>

                  <div
                    className={`flex items-center justify-between flex-1 p-4 rounded-2xl border-2 transition-all duration-300 transform ${
                      isHighlighted
                        ? `${it.bg} text-white border-transparent scale-105 shadow-2xl`
                        : `bg-transparent ${it.border}`
                    }`}
                  >

                    <div className="flex items-center gap-3">
                      <span className="text-xl">{it.icon}</span>
                      <span>{it.label}</span>
                    </div>

                    <div className="font-bold text-lg">
                      {count}
                    </div>

                  </div>

                </div>
              );
            })}

          </div>

        </div>

        {/* MEMBERS BY ATMOSPHERE */}
        <div className="flex-1 w-full flex flex-col items-center max-w-md">

          <div className="text-xl lg:text-2xl font-bold mb-6 text-center">
            Members by atmosphere
          </div>

          <div className="space-y-4 w-full">

            {ATMOSPHERE_KEYS.map((it) => {
              const count = metrics.eveningAtmosphere[it.key] || 0;
              const highlightObj = highlightedAtmosphere.find((h) => h.key === it.key);

              const isHighlighted = Boolean(highlightObj);
              const delta = highlightObj?.delta || 0;

              return (
                <div className="flex items-center gap-3" key={it.key}>

                  <div className="w-16 flex justify-end pr-2">
                    {isHighlighted && (
                      <div className="flex items-center text-lg font-bold">
                        <span className="text-2xl">{it.icon}</span>
                        <span className="ml-1">+{delta}</span>
                      </div>
                    )}
                  </div>

                  <div
                    className={`flex items-center justify-between flex-1 p-4 rounded-2xl border-2 transition-all duration-300 transform ${
                      isHighlighted
                        ? `${it.bg} border-transparent scale-105 shadow-2xl`
                        : `bg-transparent ${it.border}`
                    }`}
                  >

                    <div className="flex items-center gap-3">
                      <span className="text-xl">{it.icon}</span>
                      <span>{it.label}</span>
                    </div>

                    <div className="font-bold text-lg">
                      {count}
                    </div>

                  </div>

                </div>
              );
            })}

          </div>

        </div>

      </div>

    </div>
  );
}

// import React, { useEffect, useState, useRef } from "react";
// import { useSearchParams } from "react-router-dom";
// import { doc, onSnapshot } from "firebase/firestore";
// import { createClients } from "../firebase/clients";
//
// const INTEREST_KEYS = [
//   { key: "music", label: "Music", icon: "🎵", border: "border-[#F6A655]", bg: "bg-gradient-to-r from-[#F6A655] to-[#F2800D]" },
//   { key: "fitness", label: "Fitness", icon: "💪", border: "border-[#78C8F0]", bg: "bg-gradient-to-r from-[#67C5E4] to-[#3399CC]" },
//   { key: "art", label: "Art", icon: "🎨", border: "border-[#D98CF2]", bg: "bg-gradient-to-r from-[#CF86EA] to-[#9D54B8]" },
//   { key: "travel", label: "Travel", icon: "✈️", border: "border-[#7192F4]", bg: "bg-gradient-to-r from-[#3366CC] to-[#24368F]" },
//   { key: "food", label: "Food", icon: "🍔", border: "border-[#FFD24D]", bg: "bg-gradient-to-r from-[#EBBD60] to-[#F2A60D]" },
//   { key: "sports", label: "Sports", icon: "⚽", border: "border-[#6ED94A]", bg: "bg-gradient-to-r from-[#6DCA4E] to-[#48A329]" },
// ];
//
// const ATMOSPHERE_KEYS = [
//   { key: "date", label: "Open to date", icon: "❤️", border: "border-[#FF0000]", bg: "bg-gradient-to-r from-[#FF6B6B] to-[#FF0000]" },
//   { key: "banter", label: "Open to banter", icon: "💬", border: "border-[#FC8C4F]", bg: "bg-gradient-to-r from-[#FFB07A] to-[#FC8C4F]" },
//   { key: "vibe", label: "Just here for vibes", icon: "👻", border: "border-[#989FBB]", bg: "bg-gradient-to-r from-[#C1C6DD] to-[#989FBB]" },
// ];
//
// export default function TVDashboard() {
//   const [searchParams] = useSearchParams();
//   const eventId = searchParams.get("eventId");
//
//   const [metrics, setMetrics] = useState({
//     totalParticipants: 0,
//     interests: {},
//     eveningAtmosphere: { date: 0, banter: 0, vibe: 0 },
//   });
//
//   const [highlightedInterests, setHighlightedInterests] = useState([]);
//   const [highlightedAtmosphere, setHighlightedAtmosphere] = useState([]);
//
//   const clientsRef = useRef({});
//   const prevInterestsRef = useRef(null);
//   const prevAtmosphereRef = useRef(null);
//   const highlightTimersRef = useRef([]);
//
//   useEffect(() => {
//     if (!eventId) return;
//
//     clientsRef.current = createClients();
//     const { db } = clientsRef.current;
//
//     const unsub = onSnapshot(
//       doc(db, "events", eventId),
//       (snap) => {
//         if (!snap.exists()) return;
//
//         const data = snap.data();
//
//         const interestsData = data.interestCounters || {};
//         const atmosphereData = data.atmosphereCounters || { date: 0, banter: 0, vibe: 0 };
//         const newTotal = data.totalParticipants || 0;
//
//         if (!prevInterestsRef.current) {
//           prevInterestsRef.current = { ...interestsData };
//           prevAtmosphereRef.current = { ...atmosphereData };
//
//           setMetrics({
//             totalParticipants: newTotal,
//             interests: interestsData,
//             eveningAtmosphere: atmosphereData,
//           });
//
//           return;
//         }
//
//         const interestDeltas = INTEREST_KEYS.map(({ key }) => {
//           const diff = (interestsData[key] || 0) - (prevInterestsRef.current[key] || 0);
//           return diff > 0 ? { key, delta: diff } : null;
//         }).filter(Boolean);
//
//         if (interestDeltas.length > 0) {
//           setHighlightedInterests((prev) => [...prev, ...interestDeltas]);
//
//           const t = setTimeout(() => {
//             setHighlightedInterests((prev) =>
//               prev.filter((h) => !interestDeltas.some((d) => d.key === h.key))
//             );
//           }, 5000);
//
//           highlightTimersRef.current.push(t);
//         }
//
//         const atmosphereDeltas = ATMOSPHERE_KEYS.map(({ key }) => {
//           const diff = (atmosphereData[key] || 0) - (prevAtmosphereRef.current[key] || 0);
//           return diff > 0 ? { key, delta: diff } : null;
//         }).filter(Boolean);
//
//         if (atmosphereDeltas.length > 0) {
//           setHighlightedAtmosphere((prev) => [...prev, ...atmosphereDeltas]);
//
//           const t = setTimeout(() => {
//             setHighlightedAtmosphere((prev) =>
//               prev.filter((h) => !atmosphereDeltas.some((d) => d.key === h.key))
//             );
//           }, 5000);
//
//           highlightTimersRef.current.push(t);
//         }
//
//         prevInterestsRef.current = { ...interestsData };
//         prevAtmosphereRef.current = { ...atmosphereData };
//
//         setMetrics({
//           totalParticipants: newTotal,
//           interests: interestsData,
//           eveningAtmosphere: atmosphereData,
//         });
//       }
//     );
//
//     return () => {
//       unsub();
//       highlightTimersRef.current.forEach((t) => clearTimeout(t));
//       highlightTimersRef.current = [];
//     };
//   }, [eventId]);
//
//   const totalParticipants = metrics.totalParticipants || 0;
//
//   return (
//     <div className="min-h-screen w-full flex items-center justify-center bg-black text-white p-4 lg:p-6 overflow-x-hidden">
//
//       <div className="flex flex-col lg:flex-row gap-10 w-full max-w-7xl">
//
//         {/* TOTAL PARTICIPANTS */}
//         <div className="flex flex-col items-center justify-center flex-1 w-full max-w-xs mx-auto">
//
//           <img
//             src={process.env.PUBLIC_URL + "/goBanterHeart_red.svg"}
//             alt="Heart"
//             className="h-24 lg:h-40 mb-6 lg:mb-10"
//           />
//
//           <div className="text-2xl lg:text-4xl font-bold mb-4 text-center">
//             Total Participants
//           </div>
//
//           <div className="text-[90px] lg:text-[160px] font-bold">
//             {totalParticipants}
//           </div>
//
//         </div>
//
//         {/* MEMBERS BY INTERESTS */}
//         <div className="flex-1 w-full max-w-md mx-auto flex flex-col items-center">
//
//           <div className="text-xl lg:text-2xl font-bold mb-6 text-center">
//             Members by interests
//           </div>
//
//           <div className="space-y-4 w-full">
//
//             {INTEREST_KEYS.map((it) => {
//               const count = metrics.interests[it.key] || 0;
//               const highlightObj = highlightedInterests.find((h) => h.key === it.key);
//
//               const isHighlighted = Boolean(highlightObj);
//               const delta = highlightObj?.delta || 0;
//
//               return (
//                 <div className="flex items-center gap-3" key={it.key}>
//
//                   <div className="w-16 flex justify-end pr-2">
//                     {isHighlighted && (
//                       <div className="flex items-center text-lg font-bold">
//                         <span className="text-2xl">{it.icon}</span>
//                         <span className="ml-1">+{delta}</span>
//                       </div>
//                     )}
//                   </div>
//
//                   <div
//                     className={`flex items-center justify-between flex-1 p-4 rounded-2xl border-2 transition-all duration-300 transform ${
//                       isHighlighted
//                         ? `${it.bg} text-white border-transparent scale-105 shadow-2xl`
//                         : `bg-transparent ${it.border}`
//                     }`}
//                   >
//
//                     <div className="flex items-center gap-3">
//                       <span className="text-xl">{it.icon}</span>
//                       <span>{it.label}</span>
//                     </div>
//
//                     <div className="font-bold text-lg">
//                       {count}
//                     </div>
//
//                   </div>
//
//                 </div>
//               );
//             })}
//
//           </div>
//
//         </div>
//
//         {/* MEMBERS BY ATMOSPHERE */}
//         <div className="flex-1 w-full max-w-md mx-auto flex flex-col items-center">
//
//           <div className="text-xl lg:text-2xl font-bold mb-6 text-center">
//             Members by atmosphere
//           </div>
//
//           <div className="space-y-4 w-full">
//
//             {ATMOSPHERE_KEYS.map((it) => {
//               const count = metrics.eveningAtmosphere[it.key] || 0;
//               const highlightObj = highlightedAtmosphere.find((h) => h.key === it.key);
//
//               const isHighlighted = Boolean(highlightObj);
//               const delta = highlightObj?.delta || 0;
//
//               return (
//                 <div className="flex items-center gap-3" key={it.key}>
//
//                   <div className="w-16 flex justify-end pr-2">
//                     {isHighlighted && (
//                       <div className="flex items-center text-lg font-bold">
//                         <span className="text-2xl">{it.icon}</span>
//                         <span className="ml-1">+{delta}</span>
//                       </div>
//                     )}
//                   </div>
//
//                   <div
//                     className={`flex items-center justify-between flex-1 p-4 rounded-2xl border-2 transition-all duration-300 transform ${
//                       isHighlighted
//                         ? `${it.bg} border-transparent scale-105 shadow-2xl`
//                         : `bg-transparent ${it.border}`
//                     }`}
//                   >
//
//                     <div className="flex items-center gap-3">
//                       <span className="text-xl">{it.icon}</span>
//                       <span>{it.label}</span>
//                     </div>
//
//                     <div className="font-bold text-lg">
//                       {count}
//                     </div>
//
//                   </div>
//
//                 </div>
//               );
//             })}
//
//           </div>
//
//         </div>
//
//       </div>
//
//     </div>
//   );
// }